import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ch_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitLead = (data) => axios.post(`${API}/leads`, data);

export const login = async (email, password) => {
  const data = await api.post("/auth/login", { email, password }).then((r) => r.data);
  localStorage.setItem("ch_admin_token", data.access_token);
  return data;
};
export const fetchMe = () => api.get("/auth/me").then((r) => r.data);
export const logoutUser = () => {
  localStorage.removeItem("ch_admin_token");
  return api.post("/auth/logout").then((r) => r.data).catch(() => ({}));
};
export const fetchLeads = () => api.get("/admin/leads").then((r) => r.data);

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
